(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('timeSheetDiary', {
        templateUrl: 'views/components/views/timeSheetDiary/timeSheetDiary.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'utilityService', 'timeSheetDiaryService', 'watcherFactory', function ($stateParams, stateService, utilityService, timeSheetDiaryService, watcherFactory) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let argType = $stateParams.argtype;
            let argValue = $stateParams.argvalue;

            var watcher = watcherFactory.$create(vm);
            let onDestroy = [];

            vm.model = {
                schedulerReady: false,
                setting: {
                    portal_user_keyno: undefined,
                    date_fom: undefined,
                    selectedview: undefined
                },
                selectListPortalUsers: [],
                taskList: {
                    records: []
                },
                ownerList: {
                    records: []
                }
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region SETUP SCHEDULE FUNCTIONS

            async function setupScheduleFunctions() {
                return [
                    { name: 'add', func: function (data) { calendarChange(this.name, data); } },
                    { name: 'update', func: function (data) { calendarChange(this.name, data); } },
                    { name: 'delete', func: function (data) { calendarChange(this.name, data); } },
                    { name: 'newDate', func: function (data) { calendarChange(this.name, data); } }
                ];
            }

            async function calendarChange(name, data) {
                switch (name) {
                    case 'add':
                        console.log('Item added to setting...');
                        break;
                    case 'update':
                        timeSheetDiaryService.updateItem(data).then(function (_response) { });
                        break;
                    case 'delete':
                        console.log('Item not added...? Deleted...?');
                        break;
                    case 'newDate':
                        console.log('Item new date...');
                        break;
                    default:
                        console.log('Item default action...');
                        break;
                }
            }

            // #endregion SETUP SCHEDULE FUNCTIONS

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadSetting() {
                const info = (await timeSheetDiaryService.getSetting({
                    argtype: argType,
                    argvalue: argValue
                }))[0];
                
                vm.model.setting = info;
                vm.model.setting.functions = setupScheduleFunctions();

                return Promise.all([
                    loadPortalUsers()
                ]).then(() => {
                    loadTasks();
                    loadOwners();
                    Promise.resolve();
                });
            }

            async function loadPortalUsers() {
				if (utilityService.validateParmsValue(vm.model.setting.argtype) !== true) return;
				if (utilityService.validateParmsValue(vm.model.setting.argvalue) !== true) return;

                return vm.model.selectListPortalUsers = await timeSheetDiaryService.listPortalUsers({
                    argtype: vm.model.setting.argtype,
                    argvalue: vm.model.setting.argvalue
                });
			}

            async function loadTasks() {
				if (utilityService.validateParmsValue(vm.model.setting.date_fom) !== true) return;
				if (utilityService.validateParmsValue(vm.model.setting.portal_user_keyno) !== true) return;
				if (utilityService.validateParmsValue(vm.model.setting.selectedview) !== true) return;

				vm.model.taskList.records = [];

                return timeSheetDiaryService.listTasks(vm.model.setting).then(function (result) {
                    angular.copy(result, vm.model.taskList.records);
				});
			}

            async function loadOwners() {
				if (utilityService.validateParmsValue(vm.model.setting.date_fom) !== true) return;
				if (utilityService.validateParmsValue(vm.model.setting.portal_user_keyno) !== true) return;
				if (utilityService.validateParmsValue(vm.model.setting.selectedview) !== true) return;

				vm.model.ownerList.records = [];

                return timeSheetDiaryService.listOwners(vm.model.setting).then(function (result) {
                    angular.copy(result, vm.model.ownerList.records);
				});
			}

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region MULTI DIRECTION BUTTON FUNCTIONS

            vm.goToFunc = function (state) {
                switch (state) {
					case 'timeregister':
                        stateService.go(state, {
							custact_no: '0',
							powtime_keyno: '0'
                        });
                        break;
                    default:
                        break;
                }
            };

            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

            // #region FIELD CHANGE MULTI FUNCTIONS

            vm.onChanged = function (value, id) {
                switch (id) {
                    case 'portal_user_keyno':
                        if (utilityService.validateWatchValue(value, vm.model.setting.portal_user_keyno) !== true) return;

                        vm.model.setting.portal_user_keyno = value;

                        if (utilityService.validateParmsValue(vm.model.setting.portal_user_keyno) !== true) return;

                        loadTasks();
                        loadOwners();
                        break;
                    default:
                        utilityService.setValueToVariable(value);
                        break;
                }
            };

            // #endregion FIELD CHANGE MULTI FUNCTIONS

            // #region WATCHER FUNCTIONS

			watcher.$watch(function () {
				return vm.model.setting.date_fom;
			}, function (newValue, oldValue) {
				if (utilityService.validateWatchValue(newValue, oldValue) !== true) return;

				loadTasks();
				loadOwners();
			}, onDestroy);

			watcher.$watch(function () {
				return vm.model.setting.selectedview;
			}, function (newValue, oldValue) {
				if (utilityService.validateWatchValue(newValue, oldValue) !== true) return;

				loadTasks();
				loadOwners();
			}, onDestroy);

            // #endregion WATCHER FUNCTIONS

            // #region ON DESTROY FUNCTION

            vm.$onDestroy = function () {
                onDestroy.forEach((fn) => {
                    if (typeof fn === 'function') fn();
                });
            };

            // #endregion ON DESTROY FUNCTION

            // #region ANGULAR LIFECYCLE FUNCTION

            vm.$onInit = function () {
                loadSetting();
            };

            // #endregion ANGULAR LIFECYCLE FUNCTION

        }]
    });
})();
